import React from "react";
import { FC } from "react";
import MuiDialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "../Button";
import { ButtonProps } from "../Button";

export interface DialogProps {
  onClose: any;
  open?: boolean;
  title?: string;
  contentText?: string;
  actions?: (ButtonProps & { text: string })[];
}

const Dialog: FC<DialogProps> = ({
  open,
  title,
  onClose,
  contentText,
  actions,
}) => {
  return (
    <MuiDialog open={!!open} onClose={onClose}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {contentText && (
        <DialogContent>
          <DialogContentText>{contentText}</DialogContentText>
        </DialogContent>
      )}
      {actions && (
        <DialogActions>
          {actions.map(({ text, ...buttonProps }, index) => (
            <Button key={`DialogActionBtn_${index}`} {...buttonProps}>
              {text}
            </Button>
          ))}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default React.memo(Dialog);
